import {atom} from  "recoil"


export const Currency = atom({
    key:"Currency",
    default:"INR"
})

